<mat-stepper labelPosition="bottom" #stepper>
  <mat-step label="Register your shop" />
  <mat-step label="Set up the application" />
  <mat-step label="Fill in the catalog" />
  <mat-step label="Start selling" />
</mat-stepper>
